import { useEffect, useRef } from "react";
import "react-multi-carousel/lib/styles.css";
import { v4 as uuidv4 } from "uuid";

import sai from "../../assets/project/sai.png";
import school from "../../assets/project/school.png";
import { register } from "swiper/element/bundle";
import alnuaim from "../../assets/project/alnuaim.png";
import Mooropan from "../../assets/project/Mooropan.png";
import npcop from "../../assets/project/npcop.jpg";
import SpandanCenter from "../../assets/project/SpandanCenter-1.png";
import vms from "../../assets/project/VMS.png";
import jnpv from "../../assets/JNPV.png";
import manipal from "../../assets/manipal.png"

const Projects = () => {
  const swiperRef = useRef(null);

  useEffect(() => {
    register();

    const params = {
      // slidesPerView: 4,
      navigation: true,
      observe: true,
      observeParents: true,
      effect: "coverflow",
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 4,
        },
      },
    };

    Object.assign(swiperRef.current, params);
    swiperRef.current.initialize();
  }, []);

  let featureList = [
    {
      id: uuidv4(),
      title: "Al-Nuaim",
      image: alnuaim,
      url: "https://play.google.com/store/apps/details?id=com.alnuiam",
    },
    {
      id:uuidv4(),
      title:(<> Manipal Technologies <br/>  Limited</>),
      image:manipal,
    },
    {
      id: uuidv4(),
      title: "Vikrant Patil Office",
      image: vms,
    },
    {
      id: uuidv4(),
      title: "Spandan Center",
      image: SpandanCenter,
      url: "https://spandancentre.com/",
    },
    {
      id: uuidv4(),
      title: "MooRopan",
      image: Mooropan,
      url: "https://mooropan.in/",
    },
   { id: uuidv4(), 
    title: ( <> Jawaharlal Nehru Port <br /> Vidyalaya </> ),
     image: jnpv, 
    },
    {
      id: uuidv4(),
      title: "Sais Sanstha",
      image: sai,
      url: "https://www.saisanstha.com/",
    },
    {
      id: uuidv4(),
      title: "E.B.GADKARI HOMOEOPATHIC MEDICAL COLLEGE & HOSPITAL",
      image: school,
      url: "https://www.ebghmc.org",
    },
    {
      id: uuidv4(),
      title: "Narasu Patil College of Physiotherapy",
      image: npcop,
      url: "https://npcop.org/",
    },
  ];

  return (
    <div className="mt-10" id="reviews">
      <h2 className="text-4xl font-bold text-center text-[#0D3559] mb-12 relative">
        Our Work
        <span className="block w-24 h-1 bg-[#0d3559] mx-auto mt-3 rounded-full"></span>
      </h2>

      <div className="px-5 sm:px-20 mt-5 sm:mt-10 ">
        <swiper-container init="false" ref={swiperRef}>
          {featureList.map((item) => (
            <swiper-slide key={item.id}>
              <a
                href={item.url || "#"}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-xl"
              >
                <div className="relative w-full overflow-hidden h-80 rounded-3xl cursor-pointer text-2xl font-bold bg-[#150040] will-change-transform transform-gpu isolate ">
                  <div className="z-10 absolute w-full h-full peer"></div>

                  <div className="absolute peer-hover:-top-20 peer-hover:-left-16 peer-hover:w-[140%] peer-hover:h-[140%] -top-32 -left-16 w-32 h-44 rounded-full bg-[#290f6f] transition-all duration-500"></div>

                  <div className="absolute flex text-xl text-center items-end justify-end peer-hover:right-0 peer-hover:rounded-b-none peer-hover:bottom-0 peer-hover:items-center peer-hover:justify-center peer-hover:w-full peer-hover:h-full -bottom-32 -right-16 w-36 h-44 rounded-full bg-[#290f6f] transition-all duration-500">
                    <span className="poppins-semibold text-white">
                      {item.title}
                    </span>
                  </div>

                  <div className="w-full h-full items-center justify-center flex uppercase">
                    <img
                      className="w-full h-full object-contain"
                      src={item.image}
                      alt={item.title}
                    />
                  </div>
                </div>
              </a>
            </swiper-slide>
          ))}
        </swiper-container>
      </div>
    </div>
  );
};

export default Projects;